export class GdsgStorageByTierEntry {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "storageClass",
            "baseName": "storageClass",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalStorageBytes",
            "baseName": "totalStorageBytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return GdsgStorageByTierEntry.attributeTypeMap;
    }
    constructor() {
    }
}
